import { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Simple container for static pages with consistent padding
 */
export function PageContainer({ children, className = '' }: PageContainerProps) {
  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-900 via-slate-900 to-purple-900/20 ${className}`}>
      {children}
    </div>
  );
}
